export default {
  en: {
    translation: {
      app: {
        goToHome: 'Show the whole city',
        logoAlt: 'FloodNet logo',
        name: 'FloodNet NYC'
      },
      appMenu: {
        actions: 'Sharing',
        navigate: 'Navigate',
        open: 'Open app menu',
        title: 'App menu'
      },
      calendar: {
        title: 'Calendar'
      },
      common: {
        cancel: 'Cancel',
        empty: '-',
        justNow: 'Just Now',
        now: 'now'
      },
      drawer: {
        title: 'Explore'
      },
      floodSummary: {
        menuDescription: 'Year-by-year overview',
        title: 'Flood summary'
      },
      favorites: {
        addSelected: 'Add selected sensor',
        emptyEvents: 'No bookmarked storm events yet. Save events with the bookmark icon as that workflow is added.',
        emptyRecent: 'No recently visited sensors yet.',
        emptySensors: 'No bookmarked sensors yet. Save sensors with the bookmark icon as that workflow is added.',
        eventsTitle: 'Bookmarked Storm Events',
        openDetails: 'Open',
        recentTitle: 'Recently Visited Sensors',
        remove: 'Remove',
        selectSensorHint: 'Select a sensor on the map, then add it here.',
        sensorsTitle: 'Bookmarked Sensors',
        title: 'Bookmarks'
      },
      island: {
        collapse: 'Shrink',
        expand: 'Expand',
        hideLegend: 'Hide Table',
        showLegend: 'Show Table'
      },
      legend: {
        floodDepthOverTime: 'Flood Depth',
        major: 'Major (>= 24")',
        maxFloodDepth: 'Max Flood Depth',
        menuMax: 'Max flood depth',
        menuOverTime: 'Flood depth over time',
        minimal: 'Minimal (< 4")',
        minor: 'Minor (4-12")',
        moderate: 'Moderate (12-24")',
        none: 'None',
        offline: 'Offline',
        retired: 'Retired',
        hidePrecipitation: 'Hide precipitation layer',
        showPrecipitation: 'Show precipitation layer',
        tooltips: {
          major: 'Major flooding observed (greater than 24 inches)',
          minimal: 'Minimal flooding observed (less than 4 inches)',
          minor: 'Minor flooding observed (4 to 12 inches)',
          moderate: 'Moderate flooding observed (12 to 24 inches)',
          none: 'No flooding observed',
          offline: 'Sensor hasn\'t reported data in the last 4 hours',
          retired: 'Sensor had to be removed from this location'
        },
        whatShouldShow: 'Change what the map is showing.'
      },
      localeNames: {
        en: 'English',
        es: 'Español'
      },
      popup: {
        deployedOn: 'Deployed On',
        lastMeasurement: 'Last Measurement',
        showDetails: 'Show Details',
        zoomOut: 'Zoom Out',
        zoomTo: 'Zoom To'
      },
      route: {
        closePanel: 'Close Panel',
        copiedToClipboard: 'Copied to clipboard ',
        copyLink: 'Copy Shareable Link',
        goToShareableLink: 'Go To Shareable Link',
        goToShareablePage: 'Go To Shareable Page',
        languageMenuAria: 'Language selection menu',
        openLanguageMenu: 'Change language',
        openMainMenu: 'Open main menu',
        openSensorList: 'Open sensor list',
        openWelcomePanel: 'Open welcome message',
        share: 'Share'
      },
      sensorDetails: {
        title: 'Sensor Details'
      },
      sensorExplorer: {
        deployedSince: 'Deployed Since',
        lastDepth: 'Last Depth',
        lastMeasurementAge: 'Last Measurement Age'
      },
      sensorList: {
        active: 'Active',
        deployedOn: 'Deployed on',
        fkStatus: 'Fk Status',
        floodsObserved: 'Floods observed',
        footerAtTime: 'At {{time}}: {{count}}',
        footerNow: 'Now: {{count}}',
        footerShowing: 'Showing {{shown}} of {{total}} sensors',
        lastDepthInches: 'Last Depth Inches',
        lastFlood: 'Last flood',
        lastMeasurement: 'Last Measurement',
        maxDepthInches: 'Max depth (in)',
        maxDepthLastFloodInches: 'Max depth of last flood (in)',
        name: 'Name',
        searchPlaceholder: 'Search all sensors',
        status: 'Status',
        summary: 'Sensors: {{atTime}} at {{time}} · {{now}} now · {{allTime}} all time',
        takenDownOn: 'Taken down on',
        title: 'Sensor List'
      },
      settings: {
        autoOpenFirstTimeWelcome: 'Auto-open first-time welcome',
        contoursEnabled: 'Inundation enabled',
        dataSource: 'Data source',
        display: 'Display',
        enableDevtools: 'Enable developer tools',
        featureFlags: 'Feature flags',
        general: 'General settings',
        language: 'Language',
        languageEnglish: 'English',
        languageSpanish: 'Spanish',
        precipitationEnabled: 'Precipitation Layer',
        shortcut: 'Shortcut: Ctrl+Shift+, (Windows/Linux) or Cmd+Shift+, (macOS).',
        title: 'Settings'
      },
      stormEvents: {
        description: 'Description',
        eventCount: '{{count}} events',
        floodEventsCount: 'Flood Events Count',
        historyTitle: 'Storm history',
        hideSensorDetails: 'Hide sensor max depths',
        noEvents: 'No Events',
        rank: 'Rank',
        sensorDetailsTable: 'Sensor maximum depths',
        sensorMaxDepth: 'Max depth',
        sensorName: 'Sensor',
        sensorsInvolved: 'Sensors Involved',
        setMap: 'View on map',
        setMapTooltip: 'Update the map and timeline to this storm event',
        showSensorDetails: 'Show sensor max depths',
        showingEvents: 'Showing {{shown}} of {{total}} events',
        showMore: 'Show more',
        title: 'Storm Events',
        when: 'When'
      },
      timeControl: {
        headerTimeRange: 'Time range',
        maxDepthSummary: 'Maximum depth across selected range',
        maxDepthRangeDescription: 'Maximum depth is calculated across the selected time range.',
        noFloodingAt: 'No flooding at {{time}}.',
        noFloodingInRange: 'No flooding in this time range.',
        pause: 'Pause',
        peakMode: 'Peak Flood Depth',
        play: 'Play',
        playbackControls: 'Playback controls',
        playbackSpeed: 'Playback speed',
        speed: 'Speed',
        scrubAvailableData: 'Use the time slider to scrub through available flooding data.',
        switchToPeakMode: 'Disable time controls and show maximum depth',
        tableContextCurrent_one: '{{count}} sensor flooding at {{time}}',
        tableContextCurrent_other: '{{count}} sensors flooding at {{time}}',
        tableContextMax_one: '{{count}} sensor with flooding · Maximum depth across selected range',
        tableContextMax_other: '{{count}} sensors with flooding · Maximum depth across selected range',
        thisTime: 'this time',
        confirmRange: 'Change the map to this time range?',
        useRange: 'Use range',
        switchToTimeMode: 'Replay the storm over time',
        timeMode: 'View Flooding Over Time'
      },
      viewContext: {
        exploreOverTime: 'Explore over time',
        exploreOverTimeDescription: 'Scrub or play through this time window',
        headerShowing: 'Showing',
        latestData: 'Latest data',
        maxDepth: 'Max depth',
        maxDepthOver: 'Max Depth over',
        menuTitle: 'Choose what to show',
        openMenu: 'Change what the map is showing',
        past: 'Past',
        pastData: 'Past data',
        showLatest: 'Latest data',
        showLatestDescription: 'Monitor the current flooding conditions',
        showMaximumDepth: 'Maximum depth',
        showMaximumDepthDescription: 'Show the peak for this time range'
      },
      welcome: {
        aboutMeasurements: 'About the measurements',
        back: 'Back',
        description: 'Use the map to explore sensor observations and flood events across time.',
        dontShowAgain: 'Don\'t show this again',
        finish: 'Finish',
        firstTimeTitle: 'First-Time Welcome',
        greeting: 'Welcome to FloodNet NYC!',
        next: 'Next',
        ok: 'Got it',
        popupIntro: 'Explore where and when flooding has happened in NYC.',
        popupQuickStart: 'How to use the map',
        popupQuickStart1: 'At the top, choose what you want to see: current conditions, past flooding, or the deepest flooding during this time period.',
        popupQuickStart2: 'At the bottom, use the timeline to move backward and forward in time.',
        popupQuickStart3: 'Select a dot on the map to learn more about a sensor.',
        popupTourLink: 'start the guided tour',
        popupTourPrompt: 'Need a walkthrough?',
        measurementsDescription: 'Each sensor measures the water depth at one spot on the ground. Nearby areas may be deeper. People, trash, or plants can sometimes affect a reading, so use your best judgment when interpreting the data.',
        showing: 'This map is showing',
        showingRange: '{{from}} – {{to}}',
        tip1: 'Click a sensor to open details and charts.',
        tip2: 'Use the time controls at the bottom to scrub through events.',
        tip3: 'Click the logo to fly back to the default city view.',
        tips: 'Tips',
        tipsLabel: 'Tips:',
        title: 'FloodNet NYC Flood Explorer'
      }
    }
  },
  es: {
    translation: {
      app: {
        goToHome: 'Mostrar toda la ciudad',
        logoAlt: 'Logotipo de FloodNet',
        name: 'FloodNet NYC'
      },
      appMenu: {
        actions: 'Acciones',
        navigate: 'Navegar',
        open: 'Abrir menú de la aplicación',
        title: 'Menú de la aplicación'
      },
      calendar: {
        title: 'Calendario'
      },
      common: {
        cancel: 'Cancelar',
        empty: '-',
        justNow: 'Justo ahora',
        now: 'ahora'
      },
      drawer: {
        title: 'Explorar'
      },
      floodSummary: {
        menuDescription: 'Resumen por año',
        title: 'Resumen de inundaciones'
      },
      favorites: {
        addSelected: 'Agregar sensor seleccionado',
        emptyEvents: 'Todavía no hay eventos de tormenta favoritos. Guarda eventos con el icono de corazón cuando se agregue ese flujo.',
        emptyRecent: 'Todavía no hay sensores visitados recientemente.',
        emptySensors: 'Todavía no hay sensores favoritos. Guarda sensores con el icono de corazón cuando se agregue ese flujo.',
        eventsTitle: 'Eventos de tormenta favoritos',
        openDetails: 'Abrir detalles',
        recentTitle: 'Sensores visitados recientemente',
        remove: 'Quitar',
        selectSensorHint: 'Selecciona un sensor en el mapa y agrégalo aquí.',
        sensorsTitle: 'Sensores favoritos',
        title: 'Favoritos'
      },
      island: {
        collapse: 'Contraer',
        expand: 'Expandir',
        hideLegend: 'Ocultar tabla',
        showLegend: 'Mostrar tabla'
      },
      legend: {
        floodDepthOverTime: 'Profundidad de inundación en el tiempo',
        major: 'Mayor (>= 24")',
        maxFloodDepth: 'Profundidad máxima de inundación',
        menuMax: 'Profundidad máxima de inundación',
        menuOverTime: 'Profundidad de inundación en el tiempo',
        minimal: 'Mínimo (< 4")',
        minor: 'Menor (4-12")',
        moderate: 'Moderado (12-24")',
        none: 'Ninguno',
        offline: 'Sin conexión',
        retired: 'Retirado',
        hidePrecipitation: 'Ocultar capa de precipitación',
        showPrecipitation: 'Mostrar capa de precipitación',
        whatShouldShow: '¿Qué debemos mostrar?'
      },
      localeNames: {
        en: 'English',
        es: 'Español'
      },
      popup: {
        deployedOn: 'Instalado el',
        lastMeasurement: 'Última medición',
        showDetails: 'TODO_TRANSLATE: Show Details',
        zoomOut: 'Alejar',
        zoomTo: 'Acercar'
      },
      route: {
        closePanel: 'Cerrar panel',
        copiedToClipboard: 'Copiado al portapapeles ',
        copyLink: 'Copiar enlace compartible',
        goToShareableLink: 'Ir al enlace compartible',
        goToShareablePage: 'Ir a la página compartible',
        languageMenuAria: 'Menú de selección de idioma',
        openLanguageMenu: 'Abrir menú de idioma',
        openMainMenu: 'Abrir menú principal',
        openSensorList: 'Abrir lista de sensores',
        openWelcomePanel: 'Abrir panel de bienvenida',
        share: 'Compartir'
      },
      sensorDetails: {
        title: 'Detalles del sensor'
      },
      sensorExplorer: {
        deployedSince: 'TODO_TRANSLATE: Deployed Since',
        lastDepth: 'TODO_TRANSLATE: Last Depth',
        lastMeasurementAge: 'TODO_TRANSLATE: Last Measurement Age'
      },
      sensorList: {
        active: 'Activo',
        deployedOn: 'Instalado el',
        fkStatus: 'Estado FK',
        floodsObserved: 'Inundaciones observadas',
        footerAtTime: 'En {{time}}: {{count}}',
        footerNow: 'Ahora: {{count}}',
        footerShowing: 'Mostrando {{shown}} de {{total}} sensores',
        lastDepthInches: 'Última profundidad (in)',
        lastFlood: 'Última inundación',
        lastMeasurement: 'Última medición',
        maxDepthInches: 'Profundidad máxima (in)',
        maxDepthLastFloodInches: 'Profundidad máxima de la última inundación (in)',
        name: 'Nombre',
        searchPlaceholder: 'Buscar todos los sensores',
        status: 'Estado',
        summary: 'Sensores: {{atTime}} en {{time}} · {{now}} ahora · {{allTime}} históricos',
        takenDownOn: 'Retirado el',
        title: 'Lista de sensores'
      },
      settings: {
        autoOpenFirstTimeWelcome: 'Abrir automáticamente la bienvenida inicial',
        contoursEnabled: 'Contornos de inundación',
        dataSource: 'Fuente de datos',
        display: 'Visualización',
        enableDevtools: 'Habilitar herramientas de desarrollo',
        featureFlags: 'Banderas de funcionalidades',
        general: 'Configuración general',
        language: 'Idioma',
        languageEnglish: 'Inglés',
        languageSpanish: 'Español',
        precipitationEnabled: 'Capa de precipitación',
        shortcut: 'Atajo: Ctrl+Shift+, (Windows/Linux) o Cmd+Shift+, (macOS).',
        title: 'Configuración'
      },
      stormEvents: {
        description: 'Descripción',
        eventCount: '{{count}} eventos',
        floodEventsCount: 'Cantidad de eventos de inundación',
        historyTitle: 'Historial de tormentas',
        hideSensorDetails: 'Ocultar profundidades máximas de sensores',
        noEvents: 'No hay eventos',
        rank: 'Ordenar',
        sensorDetailsTable: 'Profundidades máximas de sensores',
        sensorMaxDepth: 'Profundidad máxima',
        sensorName: 'Sensor',
        sensorsInvolved: 'Sensores involucrados',
        setMap: 'Ver en el mapa',
        setMapTooltip: 'Actualiza el mapa y la línea de tiempo a este evento de tormenta',
        showSensorDetails: 'Mostrar profundidades máximas de sensores',
        showingEvents: 'Mostrando {{shown}} de {{total}} eventos',
        showMore: 'Mostrar más',
        title: 'Eventos de tormenta',
        when: 'Cuándo'
      },
      timeControl: {
        headerTimeRange: 'Intervalo de tiempo',
        maxDepthSummary: 'Profundidad máxima durante el intervalo seleccionado',
        maxDepthRangeDescription: 'La profundidad máxima se calcula durante el intervalo seleccionado.',
        noFloodingAt: 'No hay inundación a las {{time}}.',
        noFloodingInRange: 'No hay inundación en este intervalo de tiempo.',
        pause: 'Pausar',
        peakMode: 'Profundidad máxima de inundación',
        play: 'Reproducir',
        playbackControls: 'Controles de reproducción',
        playbackSpeed: 'Velocidad de reproducción',
        speed: 'Velocidad',
        scrubAvailableData: 'Usa el control de tiempo para recorrer los datos de inundación disponibles.',
        switchToPeakMode: 'Desactivar los controles de tiempo y mostrar la profundidad máxima',
        tableContextCurrent_one: '{{count}} sensor con inundación a las {{time}}',
        tableContextCurrent_other: '{{count}} sensores con inundación a las {{time}}',
        tableContextMax_one: '{{count}} sensor con inundación · Profundidad máxima durante el intervalo seleccionado',
        tableContextMax_other: '{{count}} sensores con inundación · Profundidad máxima durante el intervalo seleccionado',
        thisTime: 'este momento',
        confirmRange: '¿Usar este intervalo de tiempo?',
        useRange: 'Usar intervalo',
        switchToTimeMode: 'Reproducir la tormenta a lo largo del tiempo',
        timeMode: 'Ver inundación en el tiempo'
      },
      viewContext: {
        exploreOverTime: 'Explorar en el tiempo',
        exploreOverTimeDescription: 'Recorre o reproduce esta ventana de tiempo',
        headerShowing: 'Mostrando',
        latestData: 'Datos más recientes',
        maxDepth: 'Profundidad máxima',
        maxDepthOver: 'Profundidad máxima durante',
        menuTitle: 'Elige qué mostrar',
        openMenu: 'Cambiar lo que muestra el mapa',
        past: 'Pasado',
        pastData: 'Datos pasados',
        showLatest: 'Datos más recientes',
        showLatestDescription: 'Seguir el momento actual',
        showMaximumDepth: 'Profundidad máxima',
        showMaximumDepthDescription: 'Mostrar el máximo de este intervalo'
      },
      welcome: {
        aboutMeasurements: 'Una nota sobre las lecturas',
        back: 'Atrás',
        description: 'Usa el mapa para explorar observaciones de sensores y eventos de inundación en el tiempo.',
        dontShowAgain: 'No volver a mostrar esto',
        finish: 'Finalizar',
        firstTimeTitle: 'Bienvenida inicial',
        greeting: '¡Bienvenido a FloodNet NYC!',
        next: 'Siguiente',
        ok: 'Entendido',
        popupIntro: 'Usa este mapa para ver dónde ha ocurrido una inundación y cómo cambia con el tiempo.',
        popupQuickStart: 'Cómo usar el mapa',
        popupQuickStart1: 'Arriba, elige qué quieres ver: las condiciones actuales, inundaciones pasadas o la mayor profundidad durante este período.',
        popupQuickStart2: 'Abajo, usa la línea de tiempo para avanzar y retroceder en el tiempo.',
        popupQuickStart3: 'Selecciona un círculo de color para obtener más información sobre un sensor.',
        popupTourLink: 'inicia el recorrido guiado',
        popupTourPrompt: '¿Necesitas una guía?',
        measurementsDescription: 'Cada sensor mide la profundidad del agua en un solo lugar. Las áreas cercanas pueden ser más profundas. Las personas, la basura o las plantas pueden afectar una lectura, así que usa tu mejor criterio al interpretar los datos.',
        showing: 'Este mapa muestra',
        showingRange: '{{from}} – {{to}}',
        tip1: 'Haz clic en un sensor para abrir detalles y gráficos.',
        tip2: 'Usa los controles de tiempo inferiores para navegar los eventos.',
        tip3: 'Haz clic en el logo para volver a la vista predeterminada de la ciudad.',
        tips: 'Consejos',
        tipsLabel: 'Consejos:',
        title: 'Bienvenido a FloodNet NYC'
      }
    }
  }
}
